var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge tw-rounded-full tw-select-none",style:({backgroundColor: _vm.bg, color: _vm.color})},[_c('p',{staticClass:"tw-m-0"},[_vm._v(_vm._s(_vm.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }